// extracted by mini-css-extract-plugin
export default {"btn":"MyButton_btn__OYAPy"};